import { render, staticRenderFns } from "./VisaCard.vue?vue&type=template&id=0860dc0a&scoped=true"
import script from "./VisaCard.vue?vue&type=script&lang=js"
export * from "./VisaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0860dc0a",
  null
  
)

export default component.exports